/* eslint-disable */

// ** Reducers Imports
import navbar from "./navbar";
import layout from "./layout";
import auth from "./authentication";
import users from "@src/views/apps/user/store";
import email from "@src/views/apps/email/store";
import invoiceCreate from "@src/views/apps/invoiceCreate/store";
import inventory from "@src/views/apps/inventory/store";
import saleManagerManagement from "@src/views/apps/saleManagerManagement/store";
import labels from "@src/views/apps/labels/store";
import depot from "@src/views/apps/depot/store";
import state from "@src/views/apps/state/store";
import order from "@src/views/apps/order/store";
import container from "@src/views/apps/container/store";
import discount from "@src/views/apps/discount/store";
import blackList from "@src/views/apps/blackList/store";
import vendor from "@src/views/apps/vendor/store";
import commissionsByRole from "@src/views/apps/commissionsByRole/store";
import commissionsByUser from "@src/views/apps/commissionsByUser/store";
import commission from "@src/views/apps/commissions/store";
import rankingAssistant from "@src/views/apps/rankingAssistant/store";
import rankingManager from "@src/views/apps/rankingManager/store";
import rankingAgent from "@src/views/apps/rankingAgent/store";
import referralBounce from "@src/views/apps/referralBounce/store";
import refund from "@src/views/apps/refund/store";
import sumUp from "@src/views/apps/sumUp/store";
import myRefers from "@src/views/apps/myRefers/store";
import demand from "@src/views/apps/demand/store";
import orderConfirmationForm from "@src/views/apps/orderConfirmationForm/store";
import tax from "@src/views/apps/tax/store";

const rootReducer = {
  auth,
  email,
  users,
  navbar,
  layout,
  invoiceCreate,
  labels,
  depot,
  state,
  saleManagerManagement,
  order,
  inventory,
  container,
  discount,
  commissionsByRole,
  commissionsByUser,
  rankingAssistant,
  rankingManager,
  rankingAgent,
  commission,
  blackList,
  vendor,
  referralBounce,
  refund,
  sumUp,
  myRefers,
  demand,
  orderConfirmationForm,
  tax,
};

export default rootReducer;
